var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DefaultWidget", {
    attrs: { name: "导出图片", icon: "mdi-export", disabled: _vm.busy },
    on: {
      click: function ($event) {
        return _vm.exportImages()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }